import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://eyypnnpezsdlhgcdoork.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV5eXBubnBlenNkbGhnY2Rvb3JrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4MDE1OTUsImV4cCI6MjA5MzM3NzU5NX0.2nvVTRTrvYTB470E-v1Wkd1S17I0aBl_dgyLcW2y_n8';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
